// Agrupa a listagem de plantões do mês (LinhaPlantaoDTO, já filtrada por ano/mês no
// backend) pelo dia da DataTrabalho — usado para saber, ao clicar numa célula do
// calendário, quais plantões daquele dia oferecer para reagendar/cancelar. `row.data` vem
// formatada "dd/MM/yyyy" (mesmo formato de LinhaPlantaoDTO.data); não precisamos do mês
// para agrupar porque a lista já veio filtrada para o mês exibido.
export function groupShiftsByDay(shifts) {
  const byDay = {};
  for (const shift of shifts) {
    const day = Number(shift.data.split("/")[0]);
    if (!byDay[day]) byDay[day] = [];
    byDay[day].push(shift);
  }
  return byDay;
}
